import React from 'react';
import Card from '../../ui/Card';
import Button from '../../ui/Button';
import AnimatedSection from '../../common/AnimatedSection';
import {
  BookIcon,
  CalendarIcon,
  UsersIcon,
  ClubsIcon,
  DocumentAddIcon,
} from '../../ui/Icons';

export default function FeaturesGridSection() {
  const features = [
    {
      icon: <BookIcon className="w-8 h-8 text-acem-primary" />,
      title: "Espace études",
      description: "Découvrez les ressources académiques et conseils pour réussir.",
      linkTo: "/etudes/guide-inscription",
      linkText: "Accéder",
      primaryBtn: false,
    },
    {
      icon: <CalendarIcon className="w-8 h-8 text-acem-accent" />,
      title: "Événements",
      description: "Retrouvez le calendrier de nos activités associatives et sportives.",
      linkTo: "/evenements/calendrier",
      linkText: "Voir l'agenda",
      primaryBtn: false,
    },
    {
      icon: <UsersIcon className="w-8 h-8 text-acem-primary" />,
      title: "Espace Social",
      description: "Informations sur la solidarité, l'entraide et le logement.",
      linkTo: "/social/entraide",
      linkText: "S'informer",
      primaryBtn: false,
    },
    {
      icon: <ClubsIcon className="w-8 h-8 text-acem-accent" />,
      title: "Nos clubs",
      description: "Découvrez nos clubs de lecture, robotique et danses traditionnelles.",
      linkTo: "/clubs/club-lecture",
      linkText: "Découvrir",
      primaryBtn: false,
    },
    {
      icon: <DocumentAddIcon className="w-8 h-8 text-acem-primary" />,
      title: "Inscription",
      description: "Enregistrez-vous dans le recensement des étudiants comoriens.",
      linkTo: "/inscription",
      linkText: "S'inscrire",
      primaryBtn: true,
    },
  ];

  return (
    <AnimatedSection animation="stagger" selector=".feature-card" stagger={0.12} className="max-w-7xl mx-auto my-14 px-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
        {features.map((feature, idx) => (
          <Card
            key={idx}
            variant="elevated"
            className="feature-card p-6 flex flex-col justify-between items-center text-center group"
          >
            <div className="w-16 h-16 rounded-2xl bg-acem-surface-container flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-sm">
              {feature.icon}
            </div>
            <div className="space-y-2 mb-6 flex-1">
              <h3 className="font-title text-lg font-bold text-acem-primary-dark">
                {feature.title}
              </h3>
              <p className="text-xs sm:text-sm text-acem-muted leading-relaxed">
                {feature.description}
              </p>
            </div>
            <Button
              to={feature.linkTo}
              variant={feature.primaryBtn ? "primary" : "secondary"}
              size="sm"
              fullWidth
            >
              {feature.linkText}
            </Button>
          </Card>
        ))}
      </div>
    </AnimatedSection>
  );
}

